
import About from "./components/About"
import Clients from "./components/Clients"
import Header from "./components/Header"
import Hero from "./components/Hero"
import Services from "./components/Services"
import Process from "./components/Process"
import Footer from "./components/Footer"
import Contact from "./components/Contact"
import WhatsAppFloat from "./components/WhatsAppFloat"
import PoliticaDePrivacidad from "./components/politicaDePrivacidad"
import TerminosYCondiciones from "./components/terminosYCondiciones"
import { Routes, Route } from "react-router-dom"


// function App() {
//   return (
//     <div className="App font-inter">
//       <Header />
//       <Hero />
//       <Services />
//       <Clients />
//       <About />
//       <Contact />
//       <Footer />
//     </div>
//   )
// }
function LandingPage() {
  return (
    <div className="App font-inter">
      <Header />
      <Hero />
      <Services />
      <Process />
      <Clients />
      <About />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </div>
  );





}

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/terminos-y-condiciones" element={<TerminosYCondiciones />} />
      <Route path="/politica-de-privacidad" element={<PoliticaDePrivacidad />} />
    </Routes>
  );
}

export default App
